import React from 'react';

import { connect } from 'react-redux';
import RouteThumbnailsTree from '@Pages/RetroSynthesis/RouteTree/components/RouteThumbnailsTree';
import { projectRouteTreeTooltipDataChanged } from '@Pages/RetroSynthesis/ProjectRoutes/actions';
import { openRouteOverviewTreeDialog } from '@Pages/RetroSynthesis/RouteTree/RouteOverviewTreePopupContainer';
import { getRoutesTreeTooltip } from '@Pages/RetroSynthesis/ProjectRoutes/selectors';
import { typeOfRouteThumbnailDialog } from '@Pages/RetroSynthesis/RouteTree/components/RouteThumbnailsPopup';
import { updateDialog } from '@Containers/Dialogs/DialogsActions';

function RouteThumbnailsTreeContainer({
  tree,
  list,
  routeName,
  projectId,
  routeId,
  treeTooltip,
  updateTreeThumbnailDetails,
  openRouteOverviewTreePopup,
  openThumbnailPopup,
}) {
  return (
    <RouteThumbnailsTree
      tree={tree}
      list={list}
      routeName={routeName}
      onTreeNodeClick={(target, data) => {
        if (data && data.isTruncationNode) {
          openThumbnailPopup(tree, routeName, routeId);
        } else if (treeTooltip && treeTooltip.data && treeTooltip.data.id === data.id) {
          updateTreeThumbnailDetails();
        } else {
          updateTreeThumbnailDetails(target, data);
        }
      }}
      onZoomClick={(treeList, routeName) => openRouteOverviewTreePopup({ treeList, routeName, projectId, routeId })}
    />
  );
}

const mapStateToProps = (state) => ({
  treeTooltip: getRoutesTreeTooltip(state),
});

export const openThumbnailDialog = (tree, routeName, routeId) => {
  return updateDialog({
    id: typeOfRouteThumbnailDialog,
    typeOfRouteThumbnailDialog,
    dialogType: typeOfRouteThumbnailDialog,
    tree,
    routeName,
    routeId
  });
};

const mapActionToProps = {
  openThumbnailPopup: openThumbnailDialog,
  updateTreeThumbnailDetails: projectRouteTreeTooltipDataChanged,
  openRouteOverviewTreePopup: openRouteOverviewTreeDialog,
};

export default connect(mapStateToProps, mapActionToProps)(RouteThumbnailsTreeContainer);
